// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.u8QMpMZm1e74yv23yC5l {
	background-color: var(--gray);
	display: flex;
	flex-direction: column;
}

.aYO5ItflAO7g3PH4va49 {
	box-shadow: 0px 4px 16px rgba(0, 0, 0, 0.04);
	padding: 20px 32px 32px;
}

.qA7IeFkQh2lL24xYgcE7 {
	display: flex;
	flex-direction: column;
	padding: 20px 32px 32px;
}

.LRt5NCPWltZmTJ5wSM1Q {
	display: flex;
	flex-direction: column;
}

.LRt5NCPWltZmTJ5wSM1Q > * {
	border-top: 0.5px solid rgba(0, 0, 0, 0.2);
}

.Rr8CAvZ8CCH1U5o7au6m {
	color: var(--black);
	font-size: 16px;
	letter-spacing: -0.08em;
	line-height: 24px;
	margin-bottom: 8px;
}
`, "",{"version":3,"sources":["webpack://./src/pages/LockSettingsPage/IncreaseUnlockTime/IncreaseUnlockTime.pcss"],"names":[],"mappings":"AAAA;CACC,6BAA6B;CAC7B,aAAa;CACb,sBAAsB;AACvB;;AAEA;CACC,4CAA4C;CAC5C,uBAAuB;AACxB;;AAEA;CACC,aAAa;CACb,sBAAsB;CACtB,uBAAuB;AACxB;;AAEA;CACC,aAAa;CACb,sBAAsB;AACvB;;AAEA;CACC,0CAA0C;AAC3C;;AAEA;CACC,mBAAmB;CACnB,eAAe;CACf,uBAAuB;CACvB,iBAAiB;CACjB,kBAAkB;AACnB","sourcesContent":[".container {\n\tbackground-color: var(--gray);\n\tdisplay: flex;\n\tflex-direction: column;\n}\n\n.date {\n\tbox-shadow: 0px 4px 16px rgba(0, 0, 0, 0.04);\n\tpadding: 20px 32px 32px;\n}\n\n.content {\n\tdisplay: flex;\n\tflex-direction: column;\n\tpadding: 20px 32px 32px;\n}\n\n.changes {\n\tdisplay: flex;\n\tflex-direction: column;\n}\n\n.changes > * {\n\tborder-top: 0.5px solid rgba(0, 0, 0, 0.2);\n}\n\n.title {\n\tcolor: var(--black);\n\tfont-size: 16px;\n\tletter-spacing: -0.08em;\n\tline-height: 24px;\n\tmargin-bottom: 8px;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"container": `u8QMpMZm1e74yv23yC5l`,
	"date": `aYO5ItflAO7g3PH4va49`,
	"content": `qA7IeFkQh2lL24xYgcE7`,
	"changes": `LRt5NCPWltZmTJ5wSM1Q`,
	"title": `Rr8CAvZ8CCH1U5o7au6m`
};
export default ___CSS_LOADER_EXPORT___;
